import {getPublicResumeCityTop, queryEsResumeList} from "@/api/resume";

const state = {
    workplaceOption: [],    // 城市
    resumeList: [], // 人才列表
    searchParams: {
        pageSize: 10,   // 每页加载数据量
        pageNumber: 1,  // 页码
        function: '',   // 职能
        skills: '',     // 技能
        workplace: '',  // 工作地点
        keyword: '',    // 关键词
    },
    page: {
        totalElements: 0,   // 分页总数据量
    }
};

// getters
const getters = {};

const actions = {
    /** 获取人才列表*/
    getResumeList({state, commit}) {
        return new Promise((resolve, reject) => {
            queryEsResumeList(state.searchParams).then(res => {
                commit("SET_RESUME_LIST", res.data.content);
                commit("SET_RESUME_LIST_TOTAL_ELEMENTS", parseInt(res.data.totalElements));
                resolve(res);
            });
        });
    },
    /** 获取简历城市列表*/
    getResumeCityList({state, commit}) {
        return new Promise((resolve, reject) => {
            if (state.workplaceOption.length > 0) {
                return;
            }
            let cityList = [];
            getPublicResumeCityTop().then((res) => {
                res.data.forEach(x => {
                    if (x.city) {
                        cityList.push(x.city.replace("市", ""));
                    }
                });
                commit("SET_SEARCH_CITY", cityList);
            });
        });
    }
};

// mutations
const mutations = {
    /** 设置人才列表*/
    SET_RESUME_LIST(state, list) {
        state.resumeList = list;
    },
    /** 设置分页总条数*/
    SET_RESUME_LIST_TOTAL_ELEMENTS(state, size) {
        state.page.totalElements = size;
    },
    /** 设置查询条件中城市列表*/
    SET_SEARCH_CITY(state, list) {
        state.workplaceOption = list;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
